import { render, staticRenderFns } from "./Uploader.vue?vue&type=template&id=13caea7a&scoped=true"
import script from "./Uploader.vue?vue&type=script&lang=js"
export * from "./Uploader.vue?vue&type=script&lang=js"
import style0 from "./Uploader.vue?vue&type=style&index=0&id=13caea7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13caea7a",
  null
  
)

export default component.exports